module.exports = __webpack_public_path__ + "img/p2-info.5c70ee25.jpg";